import VuetifyJetValidator from 'vuetify-jet-validator'

VuetifyJetValidator.prototype.rules.isNumber = function (message) {
  if (!message) {
    message = 'It must be a number'
  }

  return v => {
    return v && isNaN(v) ? message : true
  }
}

VuetifyJetValidator.prototype.rules.numberBetween = function (min, max, message) {
  if (!message) {
    message = `Number must between ${min} and ${max}`
  }

  return v => {
    return v && (isNaN(v) || v < min || v > max) ? message : true
  }
}

export default VuetifyJetValidator
